import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import apiClient from '../lib/api'

// BRIEF-B11: one link from the /client home to the staff notice
// (/client/staff-notice, BRIEF-B10) until the owner has told their staff.
// Whether it shows is the route's to say, the same read StaffNoticePage makes:
//   GET /api/v1/day-one/staff-notice (owner only)
//     200 with staff_told_at null → the link
//     200 with a date             → nothing (confirmed)
//     a refusal (a plain member) or a failed read → nothing, no sentence
// The staff-notice route is not one of the /soc/ routes, so the call lives
// here with the staff-notice step rather than in the customer page's files.

const STAFF_NOTICE_LINK_TEXT = 'Tell your staff before we start watching'

export function StaffNoticeLink({ className }: { className?: string }) {
  const [untold, setUntold] = useState(false)

  useEffect(() => {
    let cancelled = false
    Promise.resolve()
      .then(() => apiClient.get('/day-one/staff-notice'))
      .then(
        (res) => {
          const body = res?.data as { staff_told_at?: unknown } | undefined
          if (!cancelled) setUntold(!!body && body.staff_told_at === null)
        },
        () => {},
      )
    return () => {
      cancelled = true
    }
  }, [])

  if (!untold) return null
  return (
    <div className={className}>
      <Link
        to="/client/staff-notice"
        className="inline-flex min-h-[44px] max-w-full items-center break-words rounded-lg bg-navy px-4 py-2.5 text-sm font-medium text-white hover:bg-[#2b3540] focus:outline-none focus:ring-2 focus:ring-brass focus:ring-offset-2"
      >
        {STAFF_NOTICE_LINK_TEXT}
      </Link>
    </div>
  )
}
